import { useEffect, useState } from 'react';
import {
  RAID_FV_ASSET_URLS,
  RAID_FV_BOOT_MAX_MS,
  RAID_FV_BOOT_MIN_MS,
} from '../components/raid2026/raidLogoAssets';

const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

export function prefersReducedMotion() {
  if (typeof window === 'undefined' || !window.matchMedia) {
    return false;
  }

  return window.matchMedia(REDUCED_MOTION_QUERY).matches;
}

export function delay(ms) {
  return new Promise(resolve => {
    setTimeout(resolve, ms);
  });
}

export function preloadImage(src) {
  return new Promise(resolve => {
    const image = new Image();
    image.onload = () => resolve();
    image.onerror = () => resolve();
    image.src = src;
  });
}

/**
 * FV ロゴ演出 SVG の preload と最小待機を満たすまで待つ純関数。
 * maxMs で強制完了し、個別画像の失敗でもブロックしない。
 */
export async function waitForRaidFvBoot({
  urls = RAID_FV_ASSET_URLS,
  minMs = RAID_FV_BOOT_MIN_MS,
  maxMs = RAID_FV_BOOT_MAX_MS,
  reducedMotion = prefersReducedMotion(),
} = {}) {
  const preloadPromise = Promise.all(urls.map(preloadImage));
  const minWaitPromise = reducedMotion ? Promise.resolve() : delay(minMs);

  await Promise.race([
    Promise.all([preloadPromise, minWaitPromise]),
    delay(maxMs),
  ]);

  return { reducedMotion };
}

export default function useRaidFvBoot() {
  const [state, setState] = useState(() => ({
    status: 'booting',
    reducedMotion: prefersReducedMotion(),
  }));

  useEffect(() => {
    let cancelled = false;

    waitForRaidFvBoot().then(result => {
      if (cancelled) {
        return;
      }

      setState({
        status: 'ready',
        reducedMotion: result.reducedMotion,
      });
    });

    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
